$(document).ready(function () {
  
   // Sharing tools
    $('body').on('click', '.sharing [type=button].share', function(e) {
      e.preventDefault();
      console.log("aaaaaaa");
      $('.social-sharing').toggle();
    });
  
});